export default "__VITE_ASSET__672400a4__"